import { render, staticRenderFns } from "./u-btn-arrow-outlined-circle.vue?vue&type=template&id=aaf42cf0&scoped=true&"
import script from "./u-btn-arrow-outlined-circle.vue?vue&type=script&lang=js&"
export * from "./u-btn-arrow-outlined-circle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaf42cf0",
  null
  
)

export default component.exports